import React from "react";
import PropTypes from "prop-types";
import Carousel from "../../atoms/carousel";
import Icon from "../../atoms/icon";
import { get } from "lodash";
import styles from "./styles.m.css";
import DigitalEbookStoryCard from "../../atoms/digital-ebook-story-card";
import DigitalEbookStoryCardTop from "../../atoms/digital-ebook-story-card-top";

const SliderEbookCard = ({
  collection,
  numberOfCardsInViewDesktop = 2.9,
  numberOfCardsInViewTablet = 3,
  numberOfCardsInViewMobile = 1.3,
  accentColor
}) => {
  const desktopGap = 10;
  const mobileGap = 0;

  const slides = collection.items.map(({ story }) => (
    <DigitalEbookStoryCard key={story.id} story={story} className={styles.card} />
  ));

  const topCard =
    collection && collection.items[0] ? (
      <DigitalEbookStoryCardTop
        story={collection.items[0].story}
        className={styles["top-card"]}
        bigimage={true}
        pFrom={"slider-ebook-card"}
      />
    ) : null;
  const topStory = collection.items[0].story;

  const description = get(topStory, ["cards", 0, "story-elements", 0, "text"], "E book").replace(/<[^>]*>/g, "");

  const [expanded, setExpanded] = React.useState(false);
  const maxLength = 500;
  const shortDescription = description.length > maxLength ? description.slice(0, maxLength) + "..." : description;
  return (
    <div className={styles.base}>
      <div className={`container ${styles["carousel-wrapper"]}`}>
        <div className={styles["collection-header"]}>
          <div>
            <h2 className={styles["collection-title"]}>{topStory.headline}</h2>
            <div className={styles["collection-description"]}>
              {expanded ? description : shortDescription}
              {description.length > maxLength && (
                <button className={styles["readmore-button"]} onClick={() => setExpanded(!expanded)}>
                  {expanded ? "Read Less" : "Read More"}
                  <Icon type={expanded ? "angle-up" : "angle-down"} className={styles["readmore-icon"]} />
                </button>
              )}
            </div>
          </div>
          {topCard}
        </div>
        <Carousel
          className={styles["carousel"]}
          options={{
            type: "carousel",
            perView: numberOfCardsInViewDesktop,
            gap: desktopGap,
            rewind: false,
            peek: {
              before: 0,
              after: 244
            },
            breakpoints: {
              0: {
                perView: numberOfCardsInViewMobile,
                gap: mobileGap,
                peek: {
                  before: mobileGap,
                  after: 144
                }
              },
              767: {
                perView: numberOfCardsInViewMobile,
                gap: mobileGap,
                peek: {
                  before: mobileGap,
                  after: 144
                }
              },
              991: {
                perView: numberOfCardsInViewTablet,
                gap: desktopGap,
                peek: {
                  before: desktopGap,
                  after: 244
                }
              }
            }
          }}
          renderCenterLeftControls={({ previousSlide, currentSlide }) =>
            currentSlide > 0 ? (
              <button
                aria-label="previous slide"
                role="button"
                onClick={previousSlide}
                className={`${styles["slider-nav-button"]}`}
              >
                <Icon type="angle-left" className={styles.icon} />
              </button>
            ) : null
          }
          renderCenterRightControls={({ nextSlide }) => (
            <button
              aria-label="next slide"
              role="button"
              onClick={nextSlide}
              className={`${styles["slider-nav-button"]}`}
            >
              <Icon type="angle-right" className={styles.icon} />
            </button>
          )}
          childClass={styles["glide_li"]}
        >
          {slides}
        </Carousel>
      </div>
    </div>
  );
};

SliderEbookCard.propTypes = {
  accentColor: PropTypes.string,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default SliderEbookCard;
